import {EResellerIds, getTenantData} from 'src/containers/User';
import {joi, mixed} from 'src/utils/validator';

import {getCompanyDetailsSchema} from './Modals/CompanyDetailsModal';
import {VALIDATION_SCHEMAS} from './Modals/PaymentDetailsModal';
import {showReminderModal} from './Modals/ReminderModal';
import {companyDetailsEndpoints} from './api';
import {TCompanyDetails, TPaymentDetails} from './definitions';
import {getResidentCountry} from './utils';

export const validateCompanyDetails = (details: TCompanyDetails, resellerId?: EResellerIds) => {
  const companySchema = getCompanyDetailsSchema(getResidentCountry(details?.country), {
    hasOgrn: resellerId === EResellerIds.OSK_ID,
  })(joi, mixed);

  return !companySchema.validate(details, {allowUnknown: true}).error;
};

export const validatePaymentDetails = (details: TPaymentDetails) => {
  const paymentSchema = VALIDATION_SCHEMAS[getResidentCountry(details?.country)](joi, mixed);

  return !paymentSchema.validate(details, {allowUnknown: true}).error;
};

export const showFillDetailsReminder = () => async (dispatch: TDispatch) => {
  const [{data: companyDetails}, {data: paymentDetails}, {data: tenantData}] = await Promise.all([
    dispatch(companyDetailsEndpoints.getCompanyDetails.initiate()),
    dispatch(companyDetailsEndpoints.getPaymentDetails.initiate()),
    dispatch(getTenantData.initiate()),
  ]);

  const isCompanyFilled =
    !!companyDetails && validateCompanyDetails(companyDetails, tenantData?.resellerId);

  const isPaymentFilled = !!paymentDetails && validatePaymentDetails(paymentDetails);

  if (!isCompanyFilled || !isPaymentFilled) {
    showReminderModal(!isCompanyFilled, !isPaymentFilled);
  }
};
